import { formatMoney, formatMoneyCompact, formatRateDate } from './formatMoney';

export interface CampaignBudgetFields {
  total_budget?: number | null;
  /** Absent = INR. */
  budget_currency?: string | null;
  progress?: { budget_inr?: number | null; budget_rate_date?: string | null } | null;
}

const isInr = (c?: string | null) => !c || c.toUpperCase() === 'INR';

/** The budget in INR, the basis spend is measured against. null when a foreign budget has no rate: show the typed budget only, never a percentage. */
export function budgetInInr(c: CampaignBudgetFields): number | null {
  const typed = c.total_budget ?? 0;
  if (isInr(c.budget_currency)) return typed;
  const inr = c.progress?.budget_inr;
  return typeof inr === 'number' && Number.isFinite(inr) ? inr : null;
}

/** "$5,000.00", plus "≈ ₹4,75,400.00 at 2 Nov rate" for a foreign budget that has a rate. */
export function formatCampaignBudget(c: CampaignBudgetFields): string {
  const typed = formatMoney({ amount: c.total_budget ?? 0, currency: c.budget_currency || 'INR' });
  if (isInr(c.budget_currency)) return typed;
  const inr = budgetInInr(c);
  if (inr === null) return typed;
  const day = c.progress?.budget_rate_date ? formatRateDate(c.progress.budget_rate_date) : '';
  return `${typed} ≈ ${formatMoney({ amount: inr, currency: 'INR' })}${day ? ` at ${day} rate` : ''}`;
}

/** Same shape as formatCampaignBudget, each figure compact: "$250K ≈ ₹2.37Cr at 4 Nov rate". */
export function formatCampaignBudgetCompact(c: CampaignBudgetFields): string {
  const typed = formatMoneyCompact({ amount: c.total_budget ?? 0, currency: c.budget_currency || 'INR' });
  if (isInr(c.budget_currency)) return typed;
  const inr = budgetInInr(c);
  if (inr === null) return typed;
  const day = c.progress?.budget_rate_date ? formatRateDate(c.progress.budget_rate_date) : '';
  return `${typed} ≈ ${formatMoneyCompact({ amount: inr, currency: 'INR' })}${day ? ` at ${day} rate` : ''}`;
}
